import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ExcoVideoWrapper } from 'site-modules/shared/components/exco-video/exco-video-wrapper';

export function ExcoVideoViewer({
  showTestText = false,
  maxWidth = '550px',
  minHeight = 'clamp(158px, 52vw, 317px)',
  aspectRatio = '16/9',
  marginX = 'mx-md-auto ms-lg-0 me-lg-auto',
  marginY = 'mb-md-3',
  isFitInBoxTop = false,
}) {
  return (
    <figure
      className={classnames(
        'd-flex align-items-center justify-content-center rounded-8 video-card bg-white ',
        marginX,
        marginY,
        isFitInBoxTop && 'fit-in-box-top'
      )}
      style={{
        aspectRatio,
        maxWidth,
        minHeight,
      }}
    >
      <ExcoVideoWrapper
        showTestText={showTestText}
        classes="overflow-hidden m-0_5 m-mb-1"
        styles={{
          aspectRatio: 'inherit',
        }}
      />
    </figure>
  );
}

ExcoVideoViewer.propTypes = {
  showTestText: PropTypes.bool,
  maxWidth: PropTypes.string,
  minHeight: PropTypes.string,
  aspectRatio: PropTypes.string,
  marginX: PropTypes.string,
  marginY: PropTypes.string,
  isFitInBoxTop: PropTypes.bool,
};
